import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormData } from '../features/FormRegistration';
import { getExtrasFeatureIcon } from '../utils/helpers';
import { Input, Loader, Tooltip } from '@mantine/core';
import SimpleInfoIcon from '../icons/SimpleInfoIcon';
import CheckIcon from '../icons/CheckIcon';

const PRIORITY_EXTRAS = [
  'General Dental',
  'Major Dental',
  'Optical',
  'Physiotherapy',
  'Chiropractic',
  'Remedial Massage',
  'Podiatry',
  'Hearing Aids',
];

function FeatureSelectionExtras() {
  const [showAllExtrasFeatures, setShowAllExtrasFeatures] = useState(false);

  const toggleShowMoreExtrasFeatures = () => {
    setShowAllExtrasFeatures(!showAllExtrasFeatures);
  };

  const [extrasCoverFeatures, setExtrasCoverFeatures] = useState<any>([]);

  const extrasFeaturesToShow = showAllExtrasFeatures
    ? extrasCoverFeatures
    : extrasCoverFeatures.slice(0, 8);

  const dispatch = useDispatch();
  const { formData, benefits, isBenefitsLoading } = useSelector(
    (state: any) => state.formRegistration,
  );
  const { isMobileView } = useSelector((state: any) => state.viewport);

  useEffect(() => {
    const extrasBenefits = benefits.filter(
      (feature: any) => feature.benefit_type === 'extra',
    );
    extrasBenefits.sort((a: any, b: any) => {
      const indexA = PRIORITY_EXTRAS.indexOf(a.benefit_name);
      const indexB = PRIORITY_EXTRAS.indexOf(b.benefit_name);
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return 0;
    });
    setExtrasCoverFeatures(extrasBenefits);
  }, [benefits]);

  if (isMobileView) {
    return (
      <Input.Wrapper
        label="What extras services do you need cover for?"
        description="Please select the services you require on your health insurance policy"
        className={`flex flex-col w-full gap-[15px] text-start`}>
        {' '}
        {isBenefitsLoading && <Loader />}
        {extrasFeaturesToShow.map((feature: any) => {
          const isSelected = formData.selectedExtrasBenefits.includes(
            feature.benefit_id,
          );
          return (
            <div
              key={feature.benefit_id}
              className={`border gap-[10px] relative flex font-normal w-full rounded-[8px] text-start text-[16px] cursor-pointer items-center px-[14px] py-[10px] min-h-[44px] border-[#A2AFBE]`}
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                background: isSelected ? '#17385D' : '',
                color: isSelected ? 'white' : '',
              }}
              onClick={() => {
                dispatch(
                  updateFormData({
                    ...formData,
                    selectedExtrasBenefits: isSelected
                      ? formData.selectedExtrasBenefits.filter(
                          (id: number) => id !== feature.benefit_id,
                        )
                      : [
                          ...formData.selectedExtrasBenefits,
                          feature.benefit_id,
                        ],
                  }),
                );
              }}>
              {isSelected ? (
                <div className="border flex items-center justify-center bg-[white] border-[#A2AFBE] rounded-[5px] h-[20px] w-[20px] flex-shrink-0">
                  <CheckIcon />
                </div>
              ) : (
                <div className="border border-[#A2AFBE] rounded-[5px] h-[20px] w-[20px] flex-shrink-0"></div>
              )}{' '}
              <div className="w-[25px]">
                {React.cloneElement(
                  getExtrasFeatureIcon(feature.benefit_name),
                  {
                    fillColor: isSelected ? 'white' : undefined,
                  },
                )}
              </div>
              <div className="w-full">{feature.benefit_name}</div>
              <Tooltip
                key={feature?.benefit_id}
                multiline
                label={feature?.benefit_description}
                classNames={{
                  tooltip:
                    'whitespace-pre-wrap max-w-[90%]  md:max-w-[30%] text-[14px]',
                }}
                position="bottom">
                <div className="absolute right-1 top-[20%] z-[10]">
                  <SimpleInfoIcon />
                </div>
              </Tooltip>
            </div>
          );
        })}
        <span
          className="cursor-pointer text-[16px] font-medium mt-[25px]"
          onClick={toggleShowMoreExtrasFeatures}>
          {showAllExtrasFeatures ? 'Show less -' : 'Show more +'}
        </span>
      </Input.Wrapper>
    );
  }

  return (
    <Input.Wrapper
      label="What extras services do you need cover for?"
      description="Please select the services you require on your health insurance policy"
      className={`flex flex-col w-full gap-[15px] text-start`}>
      {' '}
      {isBenefitsLoading && <Loader />}
      <div className="flex flex-col items-center">
        <div className="grid grid-cols-2 gap-[15px] w-full">
          {extrasFeaturesToShow.map((feature: any) => {
            const isSelected = formData.selectedExtrasBenefits.includes(
              feature.benefit_id,
            );
            return (
              <div
                key={feature.benefit_id}
                className={`border gap-[10px] relative flex font-normal rounded-[8px] text-start text-[16px] cursor-pointer items-center px-[14px] py-[10px] min-h-[44px] border-[#A2AFBE]`}
                style={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  background: isSelected ? '#17385D' : '',
                  color: isSelected ? 'white' : '',
                }}
                onClick={() => {
                  dispatch(
                    updateFormData({
                      ...formData,
                      selectedExtrasBenefits: isSelected
                        ? formData.selectedExtrasBenefits.filter(
                            (id: number) => id !== feature.benefit_id,
                          )
                        : [
                            ...formData.selectedExtrasBenefits,
                            feature.benefit_id,
                          ],
                    }),
                  );
                }}>
                {isSelected ? (
                  <div className="border flex items-center justify-center bg-[white] border-[#A2AFBE] rounded-[5px] h-[20px] w-[20px] flex-shrink-0">
                    <CheckIcon />
                  </div>
                ) : (
                  <div className="border border-[#A2AFBE] rounded-[5px] h-[20px] w-[20px] flex-shrink-0"></div>
                )}{' '}
                <div className="w-[25px]">
                  {React.cloneElement(
                    getExtrasFeatureIcon(feature.benefit_name),
                    {
                      fillColor: isSelected ? 'white' : undefined,
                    },
                  )}
                </div>
                <div className="w-full">{feature.benefit_name}</div>
                <Tooltip
                  key={feature?.benefit_id}
                  multiline
                  label={feature?.benefit_description}
                  classNames={{
                    tooltip:
                      'whitespace-pre-wrap max-w-[90%]  md:max-w-[30%] text-[14px]',
                  }}
                  position="bottom">
                  <div className="absolute right-1 top-[20%] z-[10]">
                    <SimpleInfoIcon />
                  </div>
                </Tooltip>
              </div>
            );
          })}
        </div>
        <span
          className="cursor-pointer text-[16px] font-medium mt-[25px] underline"
          onClick={toggleShowMoreExtrasFeatures}>
          {showAllExtrasFeatures ? 'Show less -' : 'Show more +'}
        </span>
      </div>
    </Input.Wrapper>
  );
}

export default FeatureSelectionExtras;
